import { useMemo } from 'react';
import { ROUTERS } from 'components/modules/shipper/RoutingConfiguration';
export const useDistance = ({ distance, routingType, routingConfiguration, }) => {
    return useMemo(() => {
        const isPcMiler = Boolean(routingConfiguration && routingType === ROUTERS.PC_MILER.value);
        const routerName = isPcMiler
            ? routingType
            : routingType || ROUTERS.GOOGLE_MILES.name;
        return {
            hasDistance: Boolean(distance),
            distance,
            routingType,
            routingConfiguration,
            isPcMiler,
            routerName,
        };
    }, [distance, routingType, routingConfiguration]);
};
